import { takeEvery, takeLatest } from 'redux-saga/effects';
import { POLICIES_MODULE } from '../../../configs/moduleNames';
import {
  LOAD_POLICIES_LIST,
  CREATE_POLICIES,
  DELETE_POLICIES,
  EDIT_POLICIES_BY_ID,
  LOAD_POLICIES_BY_ID,
} from '../actions';

import loadPoliciesList from './loadPoliciesList';
import createPolicies from './createPolicies';
import loadPoliciesById from './loadPoliciesById';
import editPoliciesById from './editPoliciesById';
import deletePolicies from './deletePolicies';

export default function* watchDashboard() {
  yield takeLatest(POLICIES_MODULE + LOAD_POLICIES_LIST, loadPoliciesList);
  yield takeLatest(POLICIES_MODULE + CREATE_POLICIES, createPolicies);
  yield takeEvery(POLICIES_MODULE + LOAD_POLICIES_BY_ID, loadPoliciesById);
  yield takeEvery(POLICIES_MODULE + EDIT_POLICIES_BY_ID, editPoliciesById);
  yield takeEvery(POLICIES_MODULE + DELETE_POLICIES, deletePolicies);
}
